<template>
  <div class="task-completion-section ui-designer-task">
    <prototype-section :url="link"/>

    <files-uploader
      mode="list"
      :files="initFiles"
      show-label
      big-pictures
      :img-row="3"
      :size-limit="2"
      can-picture-open>
      <template #label>
        <p class="label">
          {{ $t('UX/UI files and images') }}
        </p>
      </template>
    </files-uploader>

    <fg-input
      class="comment-input"
      :label="$t('Comment for the programmer')"
      name="Comment for the programmer">
      <textarea
        v-model="commentToProger"
        class="form-control custom-scroll"
        disabled
        placeholder=""
        rows="5"/>
    </fg-input>
  </div>
</template>

<script>
import FilesUploader from '../../../UIComponents/Custom/FilesUploader'
import PrototypeSection from '@/components/Pages/Tasks/common/PrototypeSection'
import { mapGetters } from 'vuex'
import { CREATOR_TASK_TYPES_OF_CREATE_APP, DESIGNER_TASK_TYPES } from '@/utils/constants'
import moment from "moment"

export default {
  name: 'TaskCompletionSection',
  components: {
    PrototypeSection,
    FilesUploader
  },
  data() {
    return {
      link: '',
      commentToProger: null,
      initFiles: []
    }
  },
  computed: {
    ...mapGetters(['user', 'selectedApplication']),
    mainTask() {
      if (!this.selectedApplication || !this.selectedApplication.task) return
      return this.selectedApplication.task.find(item => CREATOR_TASK_TYPES_OF_CREATE_APP.includes(item.type.name))
    }
  },
  methods: {
    getInitFiles() {
      if (!this.mainTask) return []
      const updDates = this.mainTask.files.map(item => {
        return moment(Date.parse(item.updated_at))
      })
      const lastDate = moment.max(updDates);
      const uxDesignerFiles = this.mainTask.files
        .filter(item => DESIGNER_TASK_TYPES.includes(item.type) && item.subtype === 'execution')
        .find(item => moment(item.updated_at).isSame(lastDate))
      if (!uxDesignerFiles || !uxDesignerFiles.files) return []
      return uxDesignerFiles.files
    },
    getCommentToProger() {
      if (!this.mainTask) return ''
      const isUnity = this.mainTask.type.name === 'unity_export_application'
      const developTask = isUnity ? this.mainTask.development_export : this.mainTask.development
      if (!developTask) return ''
      return developTask.comment
    }
  },
  beforeMount() {
    this.link = this.selectedApplication.prototype_link
    this.commentToProger = this.getCommentToProger()
    this.initFiles = this.getInitFiles()
  }
}
</script>

<style scoped>

</style>
